import React from 'react';
import { Grid, TabPane, Input, Dropdown, Form, DropdownProps, Button, Checkbox,} from 'semantic-ui-react';

interface AssetType {
  id: string;
  typeName: string;
}

interface ElementType {
  id: string;
  elementName: string;
}
interface ContainerBarcode {
  container_barcode: string;
  reel_count: string;
  reel_barcode: string[];
}
interface FormValues {
  title: string;
  assetType: string;
  elementType: string;
  assetId: string;
  print: string;
  containerBarcodes: ContainerBarcode[];
  notes: string;
  [key: string]: string | ContainerBarcode[]; 

}

interface HFCAssetFormProps {
  formValues: {
    title: string;
    elementType: string;
    assetType: string;
    assetId: string;
    print: string;
    containerBarcodes:ContainerBarcode[];
    notes: string;
  };
  assetData: AssetType[];
  elementData: ElementType[];
  isChecked: boolean;
  handleAssetTypeChange: (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => Promise<void>;
  handleElementTypeChange: (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => Promise<void>;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index: number) => void;
  goToNextTab: () => void;
  handleCheckboxChange:()=> void;
  titleSearch?:any;
  setFormValues: React.Dispatch<React.SetStateAction<FormValues>>;
  dropdownOpen:boolean;
  setDropdownOpen:(value: boolean) => void;
}

const HFCAssetForm: React.FC<HFCAssetFormProps> = ({
  formValues,
  assetData,
  elementData,
  handleAssetTypeChange,
  handleElementTypeChange,
  handleInputChange,
  goToNextTab,
  handleCheckboxChange,
  isChecked,
  titleSearch,
  setFormValues,
  dropdownOpen,
  setDropdownOpen
}) => {
    const assetOptions =  assetData.map(asset => ({
        key: asset.id,
        text: asset.typeName,
        value: asset.id
      }))   
    const elementOptions = elementData.map(element => ({
        key: element.id,
        text: element.elementName,
        value: element.id
      }))
      
  const isNextDisabled = formValues.title === '' || formValues.assetType === '' || formValues.elementType === '' || formValues.assetId === '' || formValues.print === '';
  
  const handleClick = (data:any) => {
    setFormValues({ ...formValues, title:data});
    setDropdownOpen(false) 
  };
  const handleMouseEnter = (event:any) => {
    event.target.style.backgroundColor = 'lightgray';
  };
  
  const handleMouseLeave = (event:any) => {
    event.target.style.backgroundColor = 'white';
  };
 
  return (
    <TabPane>
      <Form>
            <Grid stretched columns={1}>
                <Grid.Column>
                    <Form.Field>
                        <label className="mandatory-label">Title</label>
                        <div style={{position: 'relative'}}>
                        <Input
                        name="title"
                        placeholder="Title"
                        value={formValues.title}
                        onChange={(e) => handleInputChange(e, -1)}
                        />
                       {
                          (dropdownOpen && titleSearch.length > 0) && (
                            <div style={{maxHeight: '200px',  overflowY: 'auto', marginTop:'10px',marginRight: '30px',position: 'absolute', zIndex: 10, backgroundColor: 'white', border: '1px solid rgba(34, 36, 38, .15)', borderRadius: '4px', width: '100%'}}>
                              {titleSearch.map((item:any, index:any) => (
                                <div key={index} style={{padding:'5px', cursor: 'pointer'}} onClick={() => handleClick(item)} onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}>{item}</div>
                              ))}
                            </div>
                          )
                        }
                        </div>
                    </Form.Field>
                </Grid.Column>
            </Grid>
            <Grid stretched columns={2}>
                <Grid.Column>
                    <Form.Field>
                        <label className="mandatory-label">Asset Type</label>
                        <Dropdown
                        placeholder="Select Asset Type"
                        fluid
                        selection
                        options={assetOptions}
                        value={formValues.assetType}      
                        onChange={ handleAssetTypeChange}
                        />
                    </Form.Field>
                </Grid.Column>
                <Grid.Column>
                    <Form.Field>
                        <label className="mandatory-label">Element Type</label>
                        <Dropdown
                        placeholder="select Element Type"
                        fluid
                        selection
                        options={elementOptions}
                        value={formValues.elementType}
                        onChange={handleElementTypeChange}
                        />
                    </Form.Field>
                </Grid.Column>
            </Grid>
            <Grid stretched columns={2}>
                <Grid.Column>
                    <Form.Field>
                        <label className="mandatory-label">Asset ID</label>
                        <Input
                        name="assetId"
                        placeholder="Asset-Id"
                        value={formValues.assetId}
                        onChange={(e) => handleInputChange(e, -1)}
                        />
                    </Form.Field>
                    <Form.Field>
                      <Checkbox
                        label='System Generated Asset ID'
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        disabled={!formValues.title || !formValues.assetType || !formValues.elementType}
                      />
                    </Form.Field>
                </Grid.Column>
                <Grid.Column>
                <Form.Field>
                    <label className="mandatory-label">Print Number</label>
                    <Input
                    name="print"
                    placeholder="Print"
                    value={formValues.print}
                    onChange={(e) => handleInputChange(e, -1)}
                    />
                </Form.Field>
                </Grid.Column>
            </Grid>
            <div style={{textAlign: 'right', marginTop:'20px'}}>
              <Button primary onClick={goToNextTab} disabled={isNextDisabled}>Next</Button>
            </div>
      </Form>
    </TabPane>
  );
}

export default HFCAssetForm;
